<div class="container">

  @if (editing) {
    <nav mat-tab-nav-bar class="sub-nav">
      <a mat-tab-link active="active">
        @if (lookup?.id) {
          Update {{lookup?.value}}
        }
        @if (!lookup?.id) {
          Add lookup
        }
      </a>
    </nav>
  }
  <ng-container *ngTemplateOutlet="InputFormContent"></ng-container>
  <ng-container *ngTemplateOutlet="ListingContent"></ng-container>
</div>

<ng-template #ListingContent>
  <!-- lookups listing -->
  <div class="row">
    <div>&nbsp;</div>
    <div class="icons">
      <button mat-icon-button aria-label="Add lookup" color="none" [disabled]="!canEdit"
        (click)="toggleForm(null, true)">
        <mat-icon title="Add">add</mat-icon>
      </button>
    </div>
  </div>

  @if (!lookups.length) {
    <div class="mat-body-strong">
      No lookups found for this {{type}}
      <button mat-button color="accent" class="mat-inline-button" [disabled]="!canEdit" (click)="toggleForm(null, true)"
        aria-label="Add" title="Add">
      Add lookup?</button>
    </div>
  }

  <div class="list">
    @for (record of lookups; track record) {
      <div class="list-card">
        <div class="body">
          <div class="mat-subtitle-1">
            {{record.value}}
          </div>
        </div>
      </div>
    }
  </div>
  <!-- Lookup listing -->
</ng-template>


<ng-template #InputFormContent>
  <!-- Lookup Form -->
  <form #vcInputForm [formGroup]="inputForm" [class.hide]="!editing">
    <section style="display: none;">
      <input matInput type="text" formControlName="id" />
    </section>
    <!-- value section -->
    <section>
      <mat-form-field>
        <mat-label>Value</mat-label>
        <input matInput type="text" autocomplete="off" formControlName="value" [errorStateMatcher]="matcher" />
        @if (inputForm.controls.value.hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.controls.value.hasError('error')) {
          <mat-error>
            {{inputForm.controls.value.errors.error}}
          </mat-error>
        }
      </mat-form-field>
    </section>
    <!-- /value section -->

    <section>&nbsp;</section>
    <!-- Form Actions -->
    <section>
      @if (editing) {
        <div class="row">
          <button mat-stroked-button color="accent" [disabled]="!canEdit" (click)="save(inputForm)">
            @if (lookup?.id) {
              Update
            }
            @if (!lookup?.id) {
              Create
            }
          </button>
          <button mat-stroked-button (click)="onCancel()" [disabled]="!canEdit">Cancel</button>
        </div>
      }
    </section>
    <!-- Form Actions -->
  </form>
  <!-- /Input form -->
</ng-template>